export function createStopTooltipOverlay() {
  class StopTooltipOverlay extends google.maps.OverlayView {
    private position: google.maps.LatLngLiteral | null = null;
    private div: HTMLDivElement | null = null;
    private textNode: HTMLSpanElement | null = null;
    private currentText = "";

    onAdd() {
      const div = document.createElement("div");

      Object.assign(div.style, {
        position: "absolute",
        transform: "translate(-50%, -100%) translateY(40px)",
        pointerEvents: "none",
        zIndex: "9999",
      });

      const label = document.createElement("div");

      Object.assign(label.style, {
        position: "relative",
        background: "#f3eeeb",
        color: "#320010",
        border: "1px solid rgba(50, 0, 16, 0.45)",
        borderRadius: "10px",
        padding: "7px 11px",
        fontSize: "14px",
        fontWeight: "600",
        lineHeight: "1.15",
        whiteSpace: "nowrap",
        boxShadow: "0 4px 14px rgba(0, 0, 0, 0.18)",
      });

      const text = document.createElement("span");
      text.textContent = this.currentText;

      this.textNode = text;

      label.appendChild(text);
      div.appendChild(label);

      this.div = div;
      this.getPanes()?.floatPane.appendChild(div);
    }

    draw() {
      if (!this.div || !this.position) return;

      const projection = this.getProjection();
      if (!projection) return;

      const point = projection.fromLatLngToDivPixel(
        new google.maps.LatLng(this.position.lat, this.position.lng)
      );

      if (!point) return;

      this.div.style.left = `${point.x}px`;
      this.div.style.top = `${point.y}px`;
    }

    onRemove() {
      this.div?.parentNode?.removeChild(this.div);

      this.div = null;
      this.textNode = null;
    }

    show(
      map: google.maps.Map,
      position: google.maps.LatLngLiteral,
      text: string
    ) {
      this.position = position;
      this.currentText = text;

      if (this.textNode) {
        this.textNode.textContent = text;
      }

      if (!this.getMap()) {
        this.setMap(map);
      }

      this.draw();
    }

    hide() {
      this.setMap(null);
      this.position = null;
    }
  }

  return new StopTooltipOverlay();
}
